document.addEventListener('DOMContentLoaded', function () {

  const CUSTOM_ERROR_HTML = `
    <div id="custom-discount-error" style="
      color: #a32d2d;
      font-size: 13px;
      margin-top: 8px;
      line-height: 1.5;
      font-family: inherit;
    ">
      <strong>This promotional code is not valid for Live Bees or Honey Buckets. Wholesale and livestock items are excluded from standard discounts.
    </div>
  `;

  // ✅ Exact selector mil gaya HTML se
  const SHOPIFY_ERROR_SELECTORS = [
    '.mr-discount-code__error-text',      // cart drawer app (main one)
    '.cart__discount-error',              // Dawn cart page
    '.discount-error',                    // fallback
    '[data-discount-error]',              // fallback
  ];

  function findShopifyError() {
    for (const sel of SHOPIFY_ERROR_SELECTORS) {
      const el = document.querySelector(sel);
      if (el && el.textContent.trim() !== '') return el;
    }
    return null;
  }

  function replaceErrorIfExists() {
    const shopifyErr = findShopifyError();
    if (!shopifyErr) return;

    // Pehle se custom message hai toh dobara mat daalo
    if (document.getElementById('custom-discount-error')) return;

    // Shopify ka error hide karo
    shopifyErr.style.display = 'none';

    // Apna custom message insert karo
    shopifyErr.insertAdjacentHTML('afterend', CUSTOM_ERROR_HTML);
  }

  // DOM changes watch karo — jab bhi error appear ho
  const observer = new MutationObserver(function () {
    replaceErrorIfExists();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Input clear hone pe custom error bhi hatao
  document.addEventListener('input', function (e) {
    if (
      e.target.classList.contains('mr-discount-code-form__input') ||
      e.target.matches('[name="discount"], #discount-code')
    ) {
      const custom = document.getElementById('custom-discount-error');
      if (custom) custom.remove();

      // Shopify ka hidden error reset karo
      SHOPIFY_ERROR_SELECTORS.forEach(sel => {
        const el = document.querySelector(sel);
        if (el) el.style.display = '';
      });
    }
  });
});